import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
export interface User {
  given_name: string;
  family_name: string;
  email: string;
}

export interface Logs {
  log_count: number;
  thing_name: string;
  estimated_bytes: number;
}

export interface Bin {
  bin_id: string;
  bin_name: string;
  bin_model_id: string;
  bin_usage: string;
  bin_gps: string;
  bin_location: string;
  bin_address: string;
  bin_postal_code: string;
  created: number;
  modified: number;
  active: number;
  market_segment: string;
  threshold: number;
  auto_collect: number;
  client_id: string;
  bin_model_number: string;
  thing_name: string;
}

export interface DeviceEntry {
  thing_name: string;
  client_id: string;
  device_sub_group: string;
}

export interface SubGroup {
  sub_group_id: string;
  client_id: string;
  sub_group_name: string;
  devices: DeviceEntry[];
}

export interface DeviceLogSummary {
  thingName: string;
  binName: string;
  logRows: number;
  logSizeMb: number;
  subGroup: string;
}
interface ClientReportData {
  bins: Bin[];
  users: User[];
  sub_groups: SubGroup[];
  logs: Logs[];
  devices: string[];
}

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private http: HttpClient) { }

  // Function that calls API gateway to fetch a client report
    invoiceReport(client:string, start: number, end: number): Observable<any>{

       // Define the HTTP headers with content type
       const headers = new HttpHeaders({
        'Content-Type':  'application/json' // Adjust content type as needed
      });

      return this.http.post<ClientReportData>(environment.api.stage + environment.api.route.getClientInvoice,
        {
          "client_id": client,
          "from": start,
          "to": end
        }, {headers: headers}
      );
    }
}
